/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HighLevelTimeNumbers_project$ref = any;
type TimeChart_project$ref = any;
type TimeTotals_project$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TimeBudgetData_project$ref: FragmentReference;
declare export opaque type TimeBudgetData_project$fragmentType: TimeBudgetData_project$ref;
export type TimeBudgetData_project = {|
  +$fragmentRefs: TimeChart_project$ref & TimeTotals_project$ref & HighLevelTimeNumbers_project$ref,
  +$refType: TimeBudgetData_project$ref,
|};
export type TimeBudgetData_project$data = TimeBudgetData_project;
export type TimeBudgetData_project$key = {
  +$data?: TimeBudgetData_project$data,
  +$fragmentRefs: TimeBudgetData_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay",
      "type": "Int"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeBudgetData_project",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeChart_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTotals_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentMonth",
          "variableName": "currentMonth"
        },
        {
          "kind": "Variable",
          "name": "currentMonthLastDay",
          "variableName": "currentMonthLastDay"
        },
        {
          "kind": "Variable",
          "name": "currentYear",
          "variableName": "currentYear"
        }
      ],
      "kind": "FragmentSpread",
      "name": "HighLevelTimeNumbers_project"
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = 'b854853a53bd6cfb170bfc6a2f5dfd7b';

module.exports = node;
